// actions/systems/catalog.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function catalogHasErrored(bool) {
  return {
    type: 'CATALOG_HAS_ERRORED',
    hasErrored: bool
  };
}

export function catalogIsLoading(bool) {
  return {
    type: 'CATALOG_IS_LOADING',
    isLoading: bool
  };
}

export function catalogFetchDataSuccess(response) {
  return {
    type: 'CATALOG_FETCH_DATA_SUCCESS',
    response
  };
}

export function catalogFetchData(host) {
  return (dispatch) => {
    dispatch(catalogIsLoading(true));
    dispatch(catalogHasErrored(false));
    fetch(host + 'user/catalog', {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        dispatch(catalogIsLoading(false));
        promise.json()
          .then(result => {
            PubSub.publish('pubsub.systems.list', result);
            dispatch(catalogFetchDataSuccess(result));
          })
          .catch(() => dispatch(catalogHasErrored(true)));
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(catalogHasErrored(true));
      dispatch(catalogIsLoading(false));
    });
  };
}